module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financeSetA"
  }, [_c('div', {
    staticClass: "navCal"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "所有工单",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待处理",
      "name": "second"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "处理中",
      "name": "third"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已处理",
      "name": "four"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已取消",
      "name": "five"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "monewt"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单号 :"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "224px"
    },
    attrs: {
      "placeholder": "输入物流单号/工单号查询",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.orderNOA),
      callback: function($$v) {
        _vm.orderNOA = $$v
      },
      expression: "orderNOA"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "224px"
    },
    attrs: {
      "placeholder": "输入客户名称或vip号查询",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.initData()
      }
    },
    model: {
      value: (_vm.orderNOC),
      callback: function($$v) {
        _vm.orderNOC = $$v
      },
      expression: "orderNOC"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getOrderList('1')
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderMoney,
      "border": "",
      "stripe": "",
      "id": "printTable"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "工单编号",
      "prop": "orderNo",
      "min-width": "150px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.demandNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "提出时间",
      "min-width": "120px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', {
          staticStyle: {
            "flex": "8"
          }
        }, [_c('div', [_vm._v(_vm._s(scope.row.createDate))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "150px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.realName) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.vipCode) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系方式",
      "min-width": "130px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.mobile) + "\n          ")]
      }
    }])
  }), _vm._v("\n\n        >\n\n        "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('div', {
          staticStyle: {
            "color": "#d9001b"
          }
        }, [_vm._v("\n              待处理\n            ")]) : (scope.row.status == 1) ? _c('div', {
          staticStyle: {
            "color": "#f59a23"
          }
        }, [_vm._v("\n              处理中\n            ")]) : (scope.row.status == 2) ? _c('div', {
          staticStyle: {
            "color": "#70b603"
          }
        }, [_vm._v("\n              已处理\n            ")]) : (scope.row.status == -1) ? _c('div', {
          staticStyle: {
            "color": "gray"
          }
        }, [_vm._v("\n              已取消\n            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作人",
      "min-width": "100px",
      "align": "center",
      "prop": "addDate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.adminPojo ? scope.row.adminPojo.realName : "") + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "130px",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getorderNo(scope.row)
            }
          }
        }, [_vm._v("查看")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1000px",
      "title": "编辑订单",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "netBarForm",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "model": _vm.order,
      "label-width": "55px",
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "wj_dialog_panel"
  }, [_c('div', {
    staticClass: "wrl-marign"
  }, [_c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("工单号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.demandNo))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("提交时间：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.createTime))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递公司：")]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.orderInfo.expressCompany) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("快递单号：")]), _vm._v(" "), _c('div', [_vm._v("\n              " + _vm._s(_vm.orderInfo.expressNo) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("订单状态：")]), _vm._v(" "), _c('div', [(_vm.orderInfo.status == 1) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                待入库\n              ")]) : (_vm.orderInfo.status == 2) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n                已入库\n              ")]) : (_vm.orderInfo.status == 3) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n                已出库\n              ")]) : (_vm.orderInfo.status == 4) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n                已结单\n              ")]) : (_vm.orderInfo.status == -1) ? _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v("\n                已取消\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("运输类型：")]), _vm._v(" "), _c('div', [(_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodType && (_vm.orderInfo.orderPojo.goodType == 1)) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                海运\n              ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodName && (_vm.orderInfo.orderPojo.goodType == 1)) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.orderInfo.orderPojo.goodName) + "\n              ")]) : (_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodType && (_vm.orderInfo.orderPojo.goodType == 2)) ? _c('span', {
    staticStyle: {
      "color": "#f59a23"
    }
  }, [_vm._v("\n                海运大件\n              ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodName && (_vm.orderInfo.orderPojo.goodType == 2)) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.orderInfo.orderPojo.goodName) + "\n              ")]) : (_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodType && (_vm.orderInfo.orderPojo.goodType == 3)) ? _c('span', {
    staticStyle: {
      "color": "#70b603"
    }
  }, [_vm._v("\n                空运\n              ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.orderPojo && _vm.orderInfo.orderPojo.goodName && (_vm.orderInfo.orderPojo.goodType == 3)) ? _c('span', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.orderInfo.orderPojo.goodName) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "linHeight"
  }), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户名称：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.realName))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("贵宾号：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.vipCode))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("联系方式：")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderInfo.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("客户需求：")]), _vm._v(" "), (_vm.orderInfo.content) ? _c('div', {
    staticStyle: {
      "color": "#d9001b"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.orderInfo.content) + "\n            ")]) : _c('div', [_vm._v("无")])]), _vm._v(" "), _c('div', {
    staticClass: "linHeight"
  }), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("工单状态：")]), _vm._v(" "), _c('div', [_c('el-select', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.orderInfo.workOrderStatus),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "workOrderStatus", $$v)
      },
      expression: "orderInfo.workOrderStatus"
    }
  }, _vm._l((_vm.deliveyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex"
  }, [_c('div', [_vm._v("工单费用：")]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "208px"
    },
    attrs: {
      "placeholder": "本次工单收费"
    },
    model: {
      value: (_vm.orderInfo.demandMoney),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "demandMoney", $$v)
      },
      expression: "orderInfo.demandMoney"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wel-flex",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', [_vm._v("附件照片：")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wrl-felx6"
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "",
      "headers": _vm.headers,
      "http-request": _vm.handleLicenseImgFile,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.productImgA) ? _c('div', {
    staticClass: "pta"
  }, [_c('i', {
    staticClass: "el-icon-delete childe",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.del()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "81px",
      "height": "46px"
    },
    attrs: {
      "src": _vm.productImgACopy
    }
  })]) : _c('div', [_c('div', {
    staticClass: "backgroundA",
    staticStyle: {
      "width": "81px",
      "height": "46px"
    }
  }, [_vm._v("\n                      上传\n                    ")])])])], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "wrl-felx6",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "",
      "headers": _vm.headers,
      "http-request": _vm.handleLicenseImgFileB,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUploadB
    }
  }, [(_vm.productImgB) ? _c('div', {
    staticClass: "pta"
  }, [_c('i', {
    staticClass: "el-icon-delete childe",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.delB()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "81px",
      "height": "46px"
    },
    attrs: {
      "src": _vm.productImgBCopy
    }
  })]) : _c('div', [_c('div', {
    staticClass: "backgroundA",
    staticStyle: {
      "width": "81px",
      "height": "46px"
    }
  }, [_vm._v("\n                      上传\n                    ")])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "flex4"
  }, [_c('div', [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmitOrder()
      }
    }
  }, [_vm._v("提交")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wj_dialog_right"
  }, [_c('div', {
    staticClass: "wj_title"
  }, [_vm._v("反馈记录")]), _vm._v(" "), _c('div', {
    staticClass: "wj_content"
  }, _vm._l((_vm.feedback.list), function(item, index) {
    return _c('div', {
      key: index,
      class: item.type == 1 ? 'wj_item clear' : 'wj_item_right clear'
    }, [_c('div', [_c('span', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(_vm.toDate(item.operatorTime)))])]), _vm._v(" "), _c('el-avatar', {
      staticClass: "wj_avater",
      attrs: {
        "size": 32,
        "src": _vm.circleUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "wj_replay"
    }, [_vm._v(_vm._s(item.content))])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "wj_bottom"
  }, [_c('el-form', {
    ref: "feedbackForm",
    attrs: {
      "model": _vm.feedback.data,
      "rules": _vm.feedback.rules,
      "size": "medium"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "content"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px",
      "margin-left": "20px"
    },
    attrs: {
      "placeholder": "回复客户"
    },
    model: {
      value: (_vm.feedback.data.content),
      callback: function($$v) {
        _vm.$set(_vm.feedback.data, "content", $$v)
      },
      expression: "feedback.data.content"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addFeedback()
      }
    }
  }, [_vm._v("发送")])], 1)], 1)], 1)])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.showF,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "showF", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("您确认删除该图片嘛？")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.affirmB()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialog.showF = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d519129"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/workOrder/workOrderList.vue
// module id = 1245
// module chunks = 2